import { ProductCategoryListPage } from "@/features/product-category/pages/ProductCategoryListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-category/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductCategoryListPage,
});
